export default __webpack_public_path__ + "images/pencil.a630bcaff40c40aa26e59cc7f192de5d.png";